import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class MetaDataTranslationImportButton extends Button {

	render() {
		return <Button {...this.props} title={Strings.metaManagement.translation.translationSubmitButtonLabel}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">

					<circle cx="20" cy="10" r="2" />
					<path d="M20,24L20,24c-1.1,0-2-0.9-2-2v-6c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v6C22,23.1,21.1,24,20,24z" />
					<polygon points="8,24 8,22 8,20 12,20 14,20 16,20 14,20 14,16 8,16 8,14 8,12 2,18 " />
					<polygon points="26,2 10,2 10,14 12,14 12,4 24,4 24,8 28,8 28,28 12,28 12,22 10,22 10,30 30,30 30,6 " />

				</svg>
			</i>
		</Button>;
	}
}
